import { defineMessages } from 'react-intl';

const common = defineMessages({
  dismiss: {
    id: 'frontbucket.repositories.jiraIssues.onboarding.dismiss.button',
    description: 'Jira issues onboarding dismiss button label',
    defaultMessage: 'Dismiss',
  },
  done: {
    id: 'frontbucket.repositories.jiraIssues.onboarding.done.button',
    description: 'Jira issues onboarding done button label',
    defaultMessage: 'Done',
  },
  next: {
    id: 'frontbucket.repositories.jiraIssues.onboarding.next.button',
    description: 'Jira issues onboarding next button label',
    defaultMessage: 'Next',
  },
});

const step1 = defineMessages({
  title: {
    id: 'frontbucket.repositories.jiraIssues.onboarding.title.step1',
    description: 'Title for Jira issue onboarding step 1',
    defaultMessage: 'Welcome to Jira issues in Bitbucket',
  },
  description: {
    id: 'frontbucket.repositories.jiraIssues.onboarding.description.step1',
    description: 'Description for Jira issue onboarding step 1',
    defaultMessage:
      'Interact with your Jira projects by viewing and updating Jira issues within your repository, and linking code to Jira by creating branches from issues.',
  },
});

const step2 = defineMessages({
  title: {
    id: 'frontbucket.repositories.jiraIssues.onboarding.title.step2',
    description: 'Title for Jira issue onboarding step 2',
    defaultMessage: 'Find your Jira issues quickly',
  },
  description: {
    id: 'frontbucket.repositories.jiraIssues.onboarding.description.step2',
    description: 'Description for Jira issue onboarding step 2',
    defaultMessage:
      'You can search or filter by assignee, Jira projects, or issue status.',
  },
});

const step3 = defineMessages({
  title: {
    id: 'frontbucket.repositories.jiraIssues.onboarding.title.step3',
    description: 'Title for Jira issue onboarding step 3',
    defaultMessage: 'Navigate to your Jira projects',
  },
  description: {
    id: 'frontbucket.repositories.jiraIssues.onboarding.description.step3',
    description: 'Description for Jira issue onboarding step 3',
    defaultMessage: 'Use the project navigator to open your project in Jira.',
  },
});

export default { common, step1, step2, step3 };
